/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Quick_Team_Attention_SplitInputs */



/**
* | output |
* | --- |
* | "How do I divide my attention across my team?" |
*
* @param {Chat_Quick_Team_Attention_SplitInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_quick_team_attention_split = /** @type {((inputs?: Chat_Quick_Team_Attention_SplitInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Quick_Team_Attention_SplitInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Hoe verdeel ik mijn aandacht over mijn team?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Comment répartir mon attention au sein de mon équipe ?")
	return /** @type {LocalizedString} */ ("How do I divide my attention across my team?")
});